// src/Components/modules/patients/Form/ContactInfo.js

import React from "react";
import PropTypes from "prop-types";
import { Form, Input, Divider } from "antd";
import { PhoneOutlined, MailOutlined } from "@ant-design/icons";
import ResponsablesList from "./ResponsablesList";

/**
 * Componente para la sección de Contacto en el formulario de pacientes.
 * Incluye teléfono del paciente, correo y la lista de responsables.
 */
const ContactInfo = ({ form, tiposDocumento }) => {
  return (
    <>
      <Form.Item
        label="Teléfono"
        name="telefono"
        rules={[
          {
            required: true,
            message: "Por favor ingrese un teléfono.",
          },
          {
            pattern: /^\d{10}$/,
            message: "El teléfono debe contener 10 dígitos y solo números.",
          },
        ]}
      >
        <Input
          maxLength={10}
          prefix={<PhoneOutlined />}
          placeholder="Ingrese el teléfono"
        />
      </Form.Item>

      <Form.Item
        label="Correo"
        name="correo"
        rules={[
          { type: "email", message: "Por favor, ingrese un correo válido." },
        ]}
      >
        <Input prefix={<MailOutlined />} placeholder="Ingrese el correo" />
      </Form.Item>

      <Divider style={{ margin: "16px 0" }} />

      {/* Lista de responsables (reemplaza los campos planos) */}
      <ResponsablesList form={form} tiposDocumento={tiposDocumento} />
    </>
  );
};

// Validación de props con PropTypes
ContactInfo.propTypes = {
  form: PropTypes.object.isRequired,
  tiposDocumento: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      descripcion: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ContactInfo;
